import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import FAQSections from '../../../Custom/FAQ/FAQSections';
import Container from '../../../Core/Container';
import FAQSearch from '../../../Custom/FAQ/FAQSearch';

export const StyledContainer = styled(Container)`
  @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
    width: 100%;
  }
`;

export const NavBar = styled.div`
  display: flex;
  flex-direction: column;
  margin: 40px 0 24px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 56px 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin: 56px 0;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 0 30px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin: 0;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Category = styled.div`
  width: 100%;
  background-color: ${themeGet('colors.white')};
  padding: 24px 30px;

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    max-width: 841px;
    padding: 56px;
  }
`;

export const StyledFAQSearch = styled(FAQSearch)`
  margin: auto;
  max-width: 315px;
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 500px;
  }
`;

export const FAQSection = styled(FAQSections)`
  margin: 50px 0;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Header = styled.h1`
  margin-left: 30px;
  margin-top: 32px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-left: 56px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin-top: 24px;
    margin-left: 0px;
  }
`;
